import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';


import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';

import Dropzone from 'react-dropzone'
import {useDropzone} from 'react-dropzone'
import moment from 'moment';

import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

import Lang from '../modules/Lang';
import { BASE_URL } from '../consts';
import Auth from './../modules/Auth';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  formControl: {
    // width: "50%"
  },  
});

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
}

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box',
  justifyContent: 'center',
  alignItems: 'center',   
  flexDirection: 'column', 
  position: 'relative',
  zIndex: 1000
}

const thumbInner = {
  display: 'flex',
  minWidth: 0,
}

const img = {
  display: 'block',
  width: 'auto',
  maxWidth: 90,
  height: 90
}



class Thankyou extends React.Component {
	
  render(){

    const h = this.context.router.history;
    const { state, setState, storage } = this.props;

    const { language } = storage;
    const t = Lang[language];


    const { order } = state;
    // const order = {"msg":"Application has been created submitted.","output":{"while_contract_application":{"applicant":{"contact":["Daniel Borell"],"zip":"60102","name":"Nodra AB  ","city":"Norrköping","phone":"011153544","email":"daniel.borell@nodra.se","address":"Lindövägen 5b","phone_vaxel":"","organization":"556526-9445","phone_mobile":""},"contractor":{"contact":["qew"],"zip":"zcx","name":"ads","city":"231","phone":"eqw","email":"qwe@das.cxz","address":"qew","phone_vaxel":"","organization":"111111-1111","phone_mobile":""},"contract":{"sum":"213","building":"asd","concerns":"das","end_date":"2020-03-11T00:00:00.000Z","work_area":"weq","start_date":"2020-03-10T00:00:00.000Z","project_number":"213312-3122","agreement_date":"2020-03-10T00:00:00.000Z"},"assets":[],"_id":"5e674b76a3c2bf1625cf17ac","type":"Fullgörande","amount":10,"start_date":"2020-03-10T00:00:00.000Z","end_date":"2020-03-11T00:00:00.000Z","createdBy":"5dc988adba2de538a9392a31","customer":"5dc988adba2de538a9392a31","organization":"5dc98819ba2de538a9392a2d","createdAt":"2020-03-10T08:10:30.439Z","updatedAt":"2020-03-10T08:10:30.439Z","__v":0},"while_warranty_application":{"applicant":{"contact":["Daniel Borell"],"zip":"60102","name":"Nodra AB  ","city":"Norrköping","phone":"011153544","email":"daniel.borell@nodra.se","address":"Lindövägen 5b","phone_vaxel":"","organization":"556526-9445","phone_mobile":""},"contractor":{"contact":["qew"],"zip":"zcx","name":"ads","city":"231","phone":"eqw","email":"qwe@das.cxz","address":"qew","phone_vaxel":"","organization":"111111-1111","phone_mobile":""},"contract":{"sum":"213","building":"asd","concerns":"das","end_date":"2020-03-11T00:00:00.000Z","work_area":"weq","start_date":"2020-03-10T00:00:00.000Z","project_number":"213312-3122","agreement_date":"2020-03-10T00:00:00.000Z"},"assets":[],"_id":"5e674b76a3c2bf1625cf17ad","type":"Garantitid","amount":10,"start_date":"2020-03-12T00:00:00.000Z","end_date":"2022-03-11T00:00:00.000Z","createdBy":"5dc988adba2de538a9392a31","customer":"5dc988adba2de538a9392a31","organization":"5dc98819ba2de538a9392a2d","createdAt":"2020-03-10T08:10:30.523Z","updatedAt":"2020-03-10T08:10:30.523Z","__v":0}}}


    const statusColor = "#fed713";
    const statusText  = t['confirm.status.waiting_for_approval'];

    const asset_order = order && order.output && (order.output.while_contract_application || order.output.while_warranty_application);

    const thumbs = asset_order && asset_order.assets 
      && asset_order.assets.map(file => {

      return <div style={{
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 8,
        width: 60,
        height: 60,
        padding: 4,
        boxSizing: 'border-box',
        justifyContent: 'center',
        alignItems: 'center',   
        flexDirection: 'column', 
        position: 'relative',
        zIndex: 1000,
        cursor: 'pointer'
      }} 



        onClick={ () => window.open(`${BASE_URL}/auth/assets/${file.filename}?token=${Auth.getToken()}`, '_blank' ) }
        key={file._id+Math.random()}>

        { file.mimetype.includes("image") ?
          <div style={thumbInner}>
            <i className="far fa-file-image fa-2x" style={{ color: '#ddd'}} />
          </div>
        : file.mimetype.includes("pdf") ?
          <div style={thumbInner}>
            <i className="far fa-file-pdf fa-2x" style={{ color: '#ddd'}} />
          </div>
        :
          <div style={thumbInner}>
            <i className="far fa-file fa-2x" style={{ color: '#ddd'}} />
          </div>        
        }      
        
        <div style={{ width: 60, position: 'absolute', bottom: 5, left: 0, right: 0, textAlign: 'center' }}>
          <p style={{ fontSize: 10, margin: 0, overflow: "hidden", "textOverflow": "ellipsis", overflow: 'hidden', lineHeight: 1, }}>{file.originalname}</p>
        </div>

      </div>
    });

    return (
      <Card className="container" style={{ width: "90%", "textAlign": "left", padding: "50px 55px", alignItems: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '75%', textAlign: 'center' }}>
            <Typography style={{ fontSize: 30, color: "#28429e",  textTransform: "uppercase", paddingBottom: 30, margin: 0 }} gutterBottom >{t['thankyou.title']}
            </Typography>   
            <Typography style={{ fontSize: 18, color: "#28429e", paddingBottom: 0, margin: 0 }} gutterBottom >{t['thankyou.subtitle1']}
            </Typography>    
            <Typography style={{ fontSize: 18, color: "#28429e", paddingBottom: 30, margin: 0 }} gutterBottom >{t['thankyou.subtitle2']}
            </Typography>                         
          </div>  
        </div>        
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

          { order.output && order.output.while_contract_application &&

            <div style={{ width: '75%' }}>


              <div style={{  width: '100%', padding: "4px 0", display: 'flex', marginBottom: 0 }}>
                <Typography style={{ fontSize: 16, width: '50%',  textTransform: "uppercase", fontWeight: 'bold' }} gutterBottom >
                  {t['confirm.application.title']} {order.output.while_contract_application._id}
                </Typography>           
              </div>   

              <div style={{  width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9, alignItems: 'center' }}>
                <span style={{ paddingRight: "5px" }}>{t['confirm.status.title']}: </span>
                <i className="fa fa-circle" style={{ color: statusColor, fontSize: 10 }}/>
                <span style={{ paddingLeft: "5px" }}>{statusText}</span>
              </div>    

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.project_number']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.output.while_contract_application.contract.project_number }
                </Typography>              
              </div>   

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.contractor']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.output.while_contract_application.contractor.name }
                </Typography>              
              </div>          

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.sum']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.output.while_contract_application.contract.sum.replace(/(.)(?=(.{3})+$)/g,"$1 ") }
                </Typography>              
              </div>    


              <div>
                <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                  <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                    {t['confirm.summary.while_contract.type']}
                  </Typography>  
                  <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                    <i className="fas fa-flag" style={{ color: '#28429e'}} /> {t['confirm.summary.while_contract.type_name']}
                  </Typography>              
                </div>   

                <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                  <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                    {t['confirm.summary.while_contract.start_date']}
                  </Typography>  
                  <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                    { moment(order.output.while_contract_application.start_date).format("YYYY-MM-DD") }
                  </Typography>              
                </div>     

                <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                  <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                    {t['confirm.summary.while_contract.end_date']}
                  </Typography>  
                  <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                    { moment(order.output.while_contract_application.end_date).format("YYYY-MM-DD") }
                  </Typography>              
                </div>   

                <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                  <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                    {t['confirm.summary.while_contract.amount']}
                  </Typography>  
                  <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                    { order.output.while_contract_application.amount }% {t['confirm.summary.while_contract.of_sum']}
                  </Typography>              
                </div>   

              </div>          

            </div>
          }


          { order.output && order.output.while_warranty_application &&

            <div style={{ width: '75%' }}>

              <div style={{  width: '100%', padding: "4px 0", display: 'flex', marginBottom: 0 }}>
                <Typography style={{ fontSize: 16, width: '50%',  textTransform: "uppercase", fontWeight: 'bold' }} gutterBottom >
                  {t['confirm.application.title']} {order.output.while_warranty_application._id}
                </Typography>           
              </div>   

              <div style={{  width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9, alignItems: 'center' }}>
                <span style={{ paddingRight: "5px" }}>{t['confirm.status.title']}: </span>
                <i className="fa fa-circle" style={{ color: statusColor, fontSize: 10 }}/>
                <span style={{ paddingLeft: "5px" }}>{statusText}</span>
              </div>    

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.project_number']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.output.while_warranty_application.contract.project_number }
                </Typography>              
              </div>   

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.contractor']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.output.while_warranty_application.contractor.name }
                </Typography>              
              </div>      

              <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                  {t['confirm.summary.sum']}
                </Typography>  
                <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                  { order.output.while_warranty_application.contract.sum.replace(/(.)(?=(.{3})+$)/g,"$1 ") }
                </Typography>              
              </div>                      


              <div>
                <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                  <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                    {t['confirm.summary.while_warranty.type']}
                  </Typography>  
                  <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                    <i className="fas fa-flag" style={{ color: '#28429e'}} /> {t['confirm.summary.while_warranty.type_name']}
                  </Typography>              
                </div>   

                <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                  <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                    {t['confirm.summary.while_warranty.start_date']}
                  </Typography>  
                  <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                    { moment(order.output.while_warranty_application.start_date).format("YYYY-MM-DD") }
                  </Typography>              
                </div>     

                <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                  <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                    {t['confirm.summary.while_warranty.end_date']}
                  </Typography>  
                  <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                    { moment(order.output.while_warranty_application.end_date).format("YYYY-MM-DD") }
                  </Typography>              
                </div>   

                <div style={{ borderBottom: "1px solid #28429e", width: '100%', padding: "4px 0", display: 'flex', marginBottom: 9 }}>
                  <Typography style={{ fontSize: 16, width: '50%' }} gutterBottom >
                    {t['confirm.summary.while_warranty.amount']}
                  </Typography>  
                  <Typography style={{ fontSize: 16, width: '50%', textAlign: 'end' }} gutterBottom >
                    { order.output.while_warranty_application.amount }% {t['confirm.summary.while_warranty.of_sum']}
                  </Typography>              
                </div>   

              </div>      

            </div>
          }

          <div style={{ width: '75%' }}>
            <div style={{ width: '100%', padding: "4px 0", marginBottom: 9 }}>
              <Typography style={{ fontSize: 16, width: '100%' }} gutterBottom >
                {t['confirm.summary.attachments.title']}
              </Typography>  
              <div style={{ fontSize: 16, width: '100%' }} >

                { thumbs && thumbs.length 
                  ? 
                  <div>
                    {thumbs}
                  </div>
                  :
                  <div>
                    <p style={{ fontSize: 12 }}>{t['confirm.summary.attachments.no_selected.title']}</p>
                  </div>          
                } 
            
              </div>              
            </div>    
          </div>

        </div>

        <div style={{ display: 'flex' }}>
          <div style={{ width: '100%', alignItems: 'flex-end', textAlign: 'center' }}>
            <Button onClick={()=>h.push('/')} size="large" variant="contained" color="primary" style={{ fontSize: 20, margin: "30px 0px", padding: "5px 120px", "textTransform": "none", "borderRadius": "2px" }} >
                  {t['thankyou.submit.back_to_applications']}
            </Button>        
          </div>    
        </div>        
      </Card> )

    }
};


Thankyou.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
  return {
    storage: state.storage,
  };
};
const mapDispatchToProps = (dispatch) => ({

});

export default connect(  
  mapStateToProps,
  mapDispatchToProps)
(withStyles(styles)(Thankyou));